var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"contont"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"text"},[_vm._v("大数据面板")])])])
}]

export { render, staticRenderFns }